import getUserCountryFromClient from "@/lib/user-context/getUserCountryFromClient";
import { PRODUCT_TYPES } from "../constants";
import { PRODUCT_INDEX_EN } from "@/constants/algolia";
import { getFacetAttributeName } from "./getFacetAttributeName";

const getFilters = (options?: { productType?: string; indexName?: string }) => {
  const { productType, indexName: indexNameOverride } = options || {};
  const indexName = indexNameOverride || (PRODUCT_INDEX_EN as string);

  const userCountry = getUserCountryFromClient();
  const productTypeFilter = productType
    ? `product:"${productType}"`
    : PRODUCT_TYPES.map((type) => `product:"${type}"`).join(" OR ");

  // Use centralized field name mapping
  const blockedInField = getFacetAttributeName("blocked_in", { indexName });
  const allowedInField = getFacetAttributeName("allowed_in", { indexName });

  const locationRestrictionFilter = `(${blockedInField}:null OR NOT ${blockedInField}:"${userCountry}") AND (${allowedInField}:null OR ${allowedInField}:"${userCountry}")`;

  const filterString = `(${productTypeFilter}) AND ${locationRestrictionFilter}${indexName !== "product" ? " AND showInAlgoliaSearchResults:true" : ""}`;

  return filterString;
};

export default getFilters;
